var chipValue = 'fx_b6b0f3e6_1gfft351';
var chipValueHorizontalGap = 'var(--fx_b6b0f3e6_1gfft350)';

export { chipValue, chipValueHorizontalGap };
//# sourceMappingURL=value.vanilla.mjs.map
